import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { RdsBreadcrumbsModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-breadcrumbs',
  imports: [RdsBreadcrumbsModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {

  router = inject(Router);
  items = input<any[]>([]);

  navigate(breadcrumbItem: any) {
    this.router.navigate([breadcrumbItem.link], {
      queryParams: breadcrumbItem.queryParams ?? {},
    });
  }
}
